import { NUMBER_URL } from "../../constants";
import { apiSlice } from "../apiSlice";

const numberGameSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNumberQuestionsByTopic: builder.query({
      query: (numberParams) => ({
        url: `${NUMBER_URL}/topic/?topic=${numberParams.topic}&number=${numberParams.number}`,
      }),
      keepUnusedDataFor: 5,
    }),
    getAllNumberQuestions : builder.query({
      query: () => ({
        url: `${NUMBER_URL}/all`,
      }),
      keepUnusedDataFor: 5,
    }),
    getNumberQuestions : builder.query({
      query: () => ({
        url: `${NUMBER_URL}`,
      }),
      keepUnusedDataFor: 5,
    }),
  }),
});

export const { 
    useGetAllNumberQuestionsQuery,
    useGetNumberQuestionsByTopicQuery,
    useGetNumberQuestionsQuery } = numberGameSlice;